import { Loader2 } from "lucide-react"
import { Badge } from "@/components/ui/badge"

const TONES: Record<string, "neutral" | "accent" | "signal" | "muted" | "solid"> = {
  queued: "muted",
  draft: "muted",
  awaiting_approval: "signal",
  generating: "accent",
  generating_image: "accent",
  uploading: "accent",
  ready: "neutral",
  failed: "signal",
  published: "solid",
  in_meta: "accent",
  partially_failed: "signal",
  paused_in_meta: "accent",
  active: "solid",
}

const LABELS: Record<string, string> = {
  queued: "Queued",
  draft: "Draft",
  awaiting_approval: "Needs approval",
  generating: "Generating…",
  generating_image: "Generating…",
  uploading: "Uploading…",
  ready: "Ready",
  failed: "Failed",
  published: "Published",
  in_meta: "In Meta (paused)",
  partially_failed: "Partly uploaded",
  paused_in_meta: "Paused in Meta",
  active: "Active",
}

const SPINNING = new Set(["generating", "generating_image", "uploading"])

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge tone={TONES[status] ?? "neutral"}>
      {SPINNING.has(status) && <Loader2 className="mr-1 h-3 w-3 animate-spin" />}
      {LABELS[status] ?? status}
    </Badge>
  )
}
